import { render } from "./OrderItemTypeCell.vue?vue&type=template&id=0508d1bc"
import script from "./OrderItemTypeCell.vue?vue&type=script&lang=js"
export * from "./OrderItemTypeCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
